/** Must be in sync with fleet backend equivalent enum  */
export enum TimeFormat {
	FirstDateOfAllTimes = '1970-01-01',
	Year = 'year',
	Day = 'day',
	Week = 'week',
	Month = 'month',
	Zero = '0',
	DoubleZero = '00',
	Minute = 'minute',
	Hour = 'hour',
	Second = 'second',
	Minutes = 'minutes',
	Seconds = 'seconds',
	Time24Hour = 'HH:mm', // 24-hour format (e.g., 23:59)
	Time24HourSec = 'HH:mm:ss', // 24-hour format with seconds (e.g., 23:59:59)
	Time12HourAMPMSpaced = 'hh:mm A', // 12-hour format with AM/PM (e.g., 11:59 PM)
	Time12HourAMPM = 'hh:mmA', // 12-hour format without space between time and AM/PM (e.g., 11:59PM)
	Time12HourAmpmSpaced = 'hh:mm a', // 12-hour format with am/pm (e.g., 11:59 pm)
	Time12HourAmpm = 'hh:mma', // 12-hour format without space between time and am/pm (e.g., 11:59pm)
	Time24HourShort = 'H:mm', // 24-hour format and short hour support  (e.g. 9:29)
	Time24HourShortSec = 'H:mm:ss', // 24-hour format with seconds and short hour support (e.g., 9:59:59)
	DateMonthDayFullYear = 'MMM DD, YYYY',
}
